<template>
    <van-grid :column-num="3">
        <van-grid-item
            v-for="value in images"
            :key="value.id">
            <van-image 
                :src="value.img"
                fit="contain" 
                rel="external nofollow"/>
        </van-grid-item>
    </van-grid>
</template>

<script>
import { repairOrderImageApi } from '@/api/business'
import {
  Grid,
  GridItem,
  Image
} from 'vant';
export default {
  name: 'images',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image
  },
  data() {
    return {
        id: this.$route.params.id,
        images: []
    };
  },
  mounted() {
    console.log(this.$router)
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      console.log(repairOrderImageApi + '/' + that.id + '/')
      this.axios.get(repairOrderImageApi + that.id + '/').then(function (ret) {
        console.log(ret)
        that.images = ret
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
};
</script>